<template>
  <div class="shop-default">
    <div class="vip-state" v-if="isVip">vip专享优惠价格</div>
    <div class="goods-image hit-cursor" @click.stop="handleClick">
<!--      <img :src="data.image" alt="商品图片"/>-->
      <el-image :src="data.image" fit="contain" class="img"></el-image>
    </div>
    <div class="shop-default-middle">
      <div class="goods-title">{{ data.product_name }}</div>
      <div class="goods-desc">{{ data.cas_no }}</div>
      <div class="goods-desc">
        {{ data.weight || "--" }}| {{ data.purity || "--" }}
      </div>
    </div>
    <div class="shop-default-footer">
      <div class="price" v-if="isVip">
        {{ data.baojia_price || "--" }}元 {{ data.spec_type == 1 ? "+" : "" }}
        <span class="defaultPrice">原价:{{ data.price }}元</span>
      </div>
      <div class="price" v-else>
        {{ data.price || "--" }}元 {{ data.spec_type == 1 ? "+" : "" }}
      </div>

      <div class="flex-b">
        <img @click.stop="handleCartClick" @animationend="removeActive" :class="['add-car', { active: cartActive }]"
             :src="require('@/static/index/add-car.png')" alt="" class="add-car hit-cursor"/>

        <gradient-button @hit="handleAddCart" height="30px">立即购买</gradient-button>
      </div>
    </div>
    <!-- 商品规格弹窗 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" top="25vh"
               :visible.sync="dialogVisible" title="选择规格" width="30%" :before-close="handleClose">
      <div class="sku-form-box">
        <div class="item" v-for="(item, index) in data.attr" :key="item.id">
          <div class="item-title">{{ item.name }}:</div>
          <div class="item-content">
            <el-tag @click="handleSku(index, att.name)" class="hit-cursor"
                    :type="skuList[index] == att.name ? 'primary' : 'info'" v-for="att in item.attrvalue" :key="att.id">
              {{ att.name }}
            </el-tag>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div>
          <div class="price" v-if="isVip">
            {{ nowPrice.baojia_price || "--" }}元 {{ data.spec_type == 1 ? "+" : "" }}
            <span class="defaultPrice">原价:{{ nowPrice.price }}元</span>
          </div>
          <div class="price" v-else>
            {{ nowPrice.price || "--" }}元 {{ data.spec_type == 1 ? "+" : "" }}
          </div>
        </div>
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 加入购物车弹窗 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" top="25vh"
               :visible.sync="addCartDialog" :before-close="addClose" title="加入购物车" width="30%">
      <div class="sku-form-box">
        <div>
          <div class="item" v-for="(item, index) in data.attr" :key="item.id">
            <div class="item-title">{{ item.name }}:</div>
            <div class="item-content">
              <el-tag @click="handleSku(index, att.name)" class="hit-cursor sku-tag"
                      :type="skuList[index] == att.name ? 'primary' : 'info'" v-for="att in item.attrvalue"
                      :key="att.id">{{
                  att.name
                }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <div>
          <div class="price" v-if="isVip">
            {{ nowPrice.baojia_price || "--" }}元 {{ data.spec_type == 1 ? "+" : "" }}
            <span class="defaultPrice">原价:{{ nowPrice.price }}元</span>
          </div>
          <div class="price" v-else>
            {{ nowPrice.price || "--" }}元 {{ data.spec_type == 1 ? "+" : "" }}
          </div>
        </div>
        <div>
          <el-button @click.stop="addClose">取 消</el-button>
          <el-button type="primary" @click.stop="addleSave">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import gradientButton from "@/components/button/gradient-button.vue";
import {shop_cart} from "@/api/modules/home.js";

export default {
  name: "shop-default",
  components: {
    gradientButton,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      skuList: [],
      radio1: "",
      dialogVisible: false,
      addCartDialog: false,
      num: 1,
      cartActive: false,
      nowPrice: '',
    };
  },
  computed: {
    isVip() {
      return this.$store.getters.is_vip;
    },
    userInfo() {
      return this.$utils.getCookie("userInfo");
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  created() {
    if (this.data.spec_type == 0) {
      this.data.weight = this.data.spec_sku.split(",")[1];
      this.data.purity = this.data.spec_sku.split(",")[0];
    } else {
      this.data.weight = this.data.sku[0].sku.split(",")[0];
      this.data.purity = this.data.sku[0].sku.split(",")[1];
    }
  },
  methods: {
    handleClick() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
      } else {
        this.$router.push({
          path: "/shop/shopDetail",
          query: {id: this.data.id},
        });
      }
    },

    // 加入购物车弹窗
    AddCart() {
      if (this.data.spec_type == 1) {
        this.init();
        this.addCartDialog = true;
        return;
      } else {
        shop_cart({
          shop_product_id: this.data.id,
          sku: this.data.spec_sku || "0",
          cart_num: 1,
        }).then((res) => {
          if (res.data.code === 10000) {
            this.$message.success({
              message: "加入购物车成功",
              type: "success",
              offset: 300,
            });
          } else {
            this.$message.error({
              message: res.data.message,
              type: "error",
              offset: 300,
            });
          }
        });
      }
    },
    addleSave() {
      shop_cart({
        shop_product_id: this.data.id,
        sku: this.skuList.join(","),
        cart_num: 1,
      }).then((res) => {
        if (res.data.code === 10000) {
          this.$message.success({
            message: "加入购物车成功",
            type: "success",
            offset: 300,
          });
          this.skuList = [];
          this.addClose();
        } else {
          this.$message.error({
            message: res.data.message,
            type: "error",
            offset: 300,
          });
        }
      });
    },
    // 关闭加入购物车弹窗
    addClose() {
      this.addCartDialog = false;
    },
    // 选择规格
    handleSku(index, name) {
      this.skuList[index] = name;
      this.nowPrice = this.data.sku.find(item => item.sku == this.skuList.join(','))
      this.$forceUpdate();
    },
    // 多规格立即购买确定规格跳转页面
    handleSave() {
      let sku = this.skuList.join(",");
      let price = this.data.sku.find((item) => item.sku == sku);
      let data = [
        {
          product_name: this.data.product_name,
          cas_no: this.data.cas_no,
          sku: sku,
          unit: this.data.unit,
          purity: this.skuList[1],
          weight: this.skuList[0],
          custorm_price: this.isVip ? price.baojia_price : price.price,
          num: 1,
          supply_id: this.data.user_id,
          id: this.data.id,
        },
      ];
      // 将data存储到vuex中
      this.$store.commit("SET_SETTLEMENT_LIST", data);
      this.$router.push({
        path: "/shop/settlement",
        query: {
          type: "more",
          // selectedList: JSON.stringify(data),
        },
      });
      this.skuList = [];
      this.dialogVisible = false;
    },
    // 单选规格立即购买
    handleAddCart() {
      if (!this.mixCheckLogin() || !this.mixCheckUserMobile()) {
        return;
      }
      // 多规格弹窗
      if (this.data.spec_type == 1) {
        this.init();
        this.dialogVisible = true;
        return;
      } else {
        // 单规格直接跳转到购买页面
        let data = [
          {
            product_name: this.data.product_name,
            cas_no: this.data.cas_no,
            sku: this.data.spec_sku,
            unit: this.data.unit,
            purity: this.data.purity,
            weight: this.data.weight,
            supply_id: this.data.user_id,
            custorm_price: this.isVip ? this.data.baojia_price : this.data.price,
            num: 1,
            id: this.data.id,
          },
        ];
        // 将data存储到vuex中
        this.$store.commit("SET_SETTLEMENT_LIST", data);
        // 立即购买
        this.$router.push({
          path: "/shop/settlement",
          query: {
            type: "one",
            // selectedList: JSON.stringify(data),
          },
        });
      }
    },
    // 初始化规格
    init() {
      this.skuList = [];
      this.data.attr.forEach((item) => {
        this.skuList.push(item.attrvalue[0].name);
      });
      this.nowPrice = this.data.sku.find(item => item.sku == this.skuList.join(','))
    },
    // 关闭立即购买弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 点击加入购物车
    handleCartClick() {
      if (!this.mixCheckLogin() || !this.mixCheckUserAudit()) {
        return;
      }
      this.cartActive = false;
      this.$nextTick(() => {
        this.cartActive = true;
      });
      this.AddCart && this.AddCart(); // 保持原有加购物车逻辑
    },
    removeActive() {
      this.cartActive = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultPrice {
  font-weight: 400;
  color: #525666;
  text-decoration: line-through;
  font-size: var(--font-size-default-14);
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .price {
    font-weight: bold;
    font-size: 20px;
    color: #ea4335;
  }

  .defaultPrice {
    font-weight: 400;
    color: #525666;
    text-decoration: line-through;
    font-size: 14px;
  }
}


.sku-form-box {
  .item-title {
    font-weight: 600;
    margin-bottom: 4px;
    color: #333;
  }

  .item-content {
    margin-bottom: 12px;
    display: flex;
    gap: 10px;

    .sku-tag {
      margin-right: 8px;
      margin-bottom: 6px;
      font-size: 15px;
      border-radius: 8px;
      transition: all 0.2s;

    }
  }
}


.shop-default {
  width: 330px;
  border: 1px solid #e7eaf3;
  border-radius: 6px;

  .vip-state {
    display: inline-block;
    padding: 2px 10px;
    background-color: #ffe6b0;
    color: #ff9900;
    border-radius: 0 0 12px 0;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .goods-image {
    position: relative;
    width: 330px;
    height: 180px;
    border-radius: 6px 6px 0px 0px;

    // border-bottom: 1px solid #e7eaf3;
    .img {
      width: 100%;
      height: 100%;
      border-radius: 6px 6px 0px 0px;
      object-fit: contain;
    }
  }

  .shop-default-middle {
    padding: 12px 20px;
    border-bottom: 1px solid #e7eaf3;

    .goods-title {
      font-weight: bold;
      font-size: var(--font-size-default-16);
      color: #525666;
      line-height: 33px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .goods-desc {
      font-weight: 400;
      font-size: var(--font-size-default-14);
      color: #7a8199;
      line-height: 28px;
    }
  }

  .shop-default-footer {
    padding: 0 20px 20px;

    .add-car {
      width: 35px;
      height: 30px;
    }

    .price {
      line-height: 50px;
      font-weight: bold;
      font-size: var(--font-size-default-18);
      color: #ea4335;
    }
  }
}

.add-car {
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.add-car:hover {
  transform: scale(1.15) rotate(-10deg);
}

.add-car.active {
  animation: cart-bounce 0.4s;
}

@keyframes cart-bounce {
  0% {
    transform: scale(1) rotate(0deg);
  }

  30% {
    transform: scale(0.9) rotate(10deg);
  }

  60% {
    transform: scale(1.2) rotate(-10deg);
  }

  100% {
    transform: scale(1) rotate(0deg);
  }
}
</style>
